import React,{useState} from 'react'
import {featchWeather} from './api/featchWheather'
import './App.css'

const App =()=>{

    const [city,setCity]=useState('');
    const [wheather,setWheather]=useState({});

    const search=async(e)=>{
        if(e.key==='Enter'){
            const data=await featchWeather(city)
            //we are updating the object to setWheather and wheather is now accessible to whole app.js
            setWheather(data);
            //to reset it to empty we need to update the setCity to empty
            setCity('');
        }
    }
    return(
        <div className="main-container">
            <input
            type="text"
            placeholder="Search..."
            className="search"
            value={city}
            onChange={(e)=>setCity(e.target.value)}
            onKeyPress={search}
            />
            {
                wheather.main &&(
                    <div className="city">
                        <h2 className="city-name">
                            <span>{wheather.name}</span>
                            <sup>{wheather.sys.country}</sup>
                        </h2>
                        <div className="city-temp">
                            {Math.round(wheather.main.temp)}
                            {//this is to write the notations of the celcius
                                }
                            <sup>&deg;C</sup>
                        </div>
                        <div className="info">
                            {console.log(wheather)}
                            <img className="city-icon" src={`https://openweathermap.org/img/wn/${wheather.weather[0].icon}@2x.png`} alt={wheather.weather[0].description}/>
                            <p>{wheather.weather[0].description}</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
}
export default App;

//npm run build makes the project production ready in build folder all the files related to a website gets 
//generated.open terminal and run npm run build
//and drag and drop the file